<template>
  <el-dialog :title="$t('couponManage.giveCoupon')" :visible.sync="dialogVisible" width="500px"
    @close="handleClose">
    <el-form ref="form" :model="giveCouponInfo" label-width="100px">
      <el-form-item :label="$t('couponManage.couponName')">
        <el-input v-model="giveCouponInfo.couponName" disabled />
      </el-form-item>
      <el-form-item :label="$t('couponManage.phoneNumber')"
        :rules="[{ required: true, message: $t('couponManage.phoneNumberRequired'), trigger: 'blur' }]">
        <el-input v-model="giveCouponInfo.tel"
          :placeholder="$t('couponManage.phoneNumberPlaceholder')" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="giveCouponMethod">
        {{ $t('couponManage.give') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { giveCoupon } from '@/api/coupon/couponApi'

export default {
  name: 'GiveCoupon',
  data() {
    return {
      dialogVisible: false,
      giveCouponInfo: {
        couponId: '',
        couponName: '',
        tel: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.giveCouponInfo.couponId = row.couponId
      this.giveCouponInfo.couponName = row.couponName
      this.giveCouponInfo.tel = ''
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.giveCouponInfo = {
        couponId: '',
        couponName: '',
        tel: ''
      }
    },
    async giveCouponMethod() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              await giveCoupon({
                couponId: this.giveCouponInfo.couponId,
                tel: this.giveCouponInfo.tel
              })
              this.$message.success(this.$t('couponManage.giveSuccess'))
              this.dialogVisible = false
              this.$emit('refresh')
            } catch (error) {
              this.$message.error(error || this.$t('couponManage.giveFailed'))
            }
          }
        })
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>

